import { FunctionComponent } from 'react';
import { PrintArea, View } from '@/types/entities';
import { getViewMapByPrintArea } from '@/model/productType/getViewMapByPrintArea';

interface Props {
  readOnly: boolean;
  x: number;
  y: number;
  view: View;
  printArea?: PrintArea;
  isPrintAreaSelected: boolean;
}
export const Defs: FunctionComponent<Props> = ({
  readOnly,
  x,
  y,
  view,
  printArea,
  isPrintAreaSelected,
}) => {
  if (readOnly || !printArea) {
    return null;
  }

  const viewMap = getViewMapByPrintArea(view, printArea);
  const boundary = printArea.boundary;

  return (
    <defs>
      {/* adds a white background under the svg-element it gets applied to */}
      <filter x="-0.05" y="-0.05" width="1.1" height="1.1" id="bg">
        <feFlood floodColor="#fff" />
      </filter>
      <mask id="mask">
        <rect width={x} height={y} fill={isPrintAreaSelected ? '#d3d3d3' : 'transparent'}></rect>
        <g transform={`translate(${viewMap.offset.x}, ${viewMap.offset.y})`}>
          <rect width={boundary.size.width} height={boundary.size.height} fill="#000"></rect>
        </g>
      </mask>
    </defs>
  );
};
